
import React from "react";
import { RegulationItem } from "../RegulationItem";
import { Info } from "lucide-react";

export const FishingAreas = () => {
  return (
    <RegulationItem 
      value="areas" 
      icon={Info} 
      title="Fishing Areas"
    >
      <p className="text-tribal-neutral">
        Fishing allowed everywhere on reservoirs except within 50 yards of inlet canals.
      </p>
    </RegulationItem>
  );
};
